import React from "react";

import Link from "./Link";
import LogoImage from "./LogoImage";
import SearchForm from "./SearchForm";

export function TopNav(props) {
  const {
    website: {
      website_shorthand,
      website_header,
      head_logo,
      head_logo_link,
      host,
      site_flag_url,
    },
    entity,
    entity: { urls },
    menu: { display_search, main_logo },
  } = props;

  if (urls.length < 1) {
    return null;
  }

  const renderHeader = () => {
    if (display_search) {
      return (
        <section className="m-site-btn-group--header-context">
          <SearchForm host={entity.host} />
        </section>
      );
    } else if (website_shorthand) {
      return (
        <section className="m-site-btn-group--header-context">
          <a
            data-testid="t-TopNav-a"
            className="m-site-btn-flag"
            href={`//${website_shorthand}`}>
            <span className="secondary-color-text">{website_shorthand}</span>
          </a>
        </section>
      );
    } else if (website_header) {
      return (
        <section className="m-site-btn-group--header-context">
          <a
            data-testid="t-TopNav-a-2"
            className="m-site-btn-flag"
            href={`//${site_flag_url || host}`}>
            <span className="secondary-color-text">{site_flag_url || host}</span>
          </a>
        </section>
      );
    }
  };

  return (
    <div className="m-site-nav primary-color-background">
      <header className="container navbar-fixed-top m-site-header">
        <div className="m-site-header-container">
          <LogoImage
            alt={entity.name}
            logo={main_logo || head_logo}
            logoLink={head_logo_link}
            _imageClassName="m-site-logo"
          />
          <div className="flex-center-all">
            <nav className="m-site-nav-inline-top">
              <ul className="m-site-nav-inline--secondary">
                {urls.map((url) => (
                  <li key={url.id} className="m-site-nav-inline--secondary__item">
                    <em>
                      <Link text={url.name} {...url} />
                    </em>
                  </li>
                ))}
              </ul>
            </nav>
            {renderHeader()}
          </div>
        </div>
      </header>
    </div>
  );
}

export default TopNav;
